(function () {
    'use strict';

    angular
        .module('Lavpop-store.constants', [])
        .constant('LOCAL_STORAGE_ITEMS', {
            ACCESS_TOKEN: 'LavpopSSOAccessToken',
            ACCESS_TOKEN_REFRESH: 'LavpopSSORefreshAccessToken',
            ACCESS_TOKEN_EXPIRATION: 'LavpopSSOAccessTokenExpiration',
            ACCESS_TOKEN_OWNER: 'LavpopSSOAccessTokenOwner',
            USER_CART: 'LavpopStoreCart',
            USER_CART_EXPIRATION: 'LavpopStoreCartExpiration'
        })
        .constant('AUTH_EVENTS', {
            NOT_AUTHENTICATED: 'auth-not-authenticated'
        })
        .constant('DATA_EVENTS', {
            SELECTED_UNIT_CHANGE: 'selected-unit-change'
        })
        .constant('KEYS', {
            CLIENT_ID: 'W0fks3O0C7H4uXs4c44IeIuDqC4580co'
        })
        .constant('PATHS', {
            PHYSICAL: '/app/src/angular'
        })
        .constant('ROUTES', {
            // Host da TELA do SSO: serve /login e hub.html (cross-storage). NAO e' a API.
            CENTRAL_CONTAS: 'https://sso-dev.lavpop.com.br/',
            // API do SSO. Separada porque a API migrou para o Froth e a tela nao.
            SSO_API: 'https://sso-dev.lavpop.com.br/api/',
            APP: 'https://central-dev.lavpop.com.br',
            API: 'https://central-dev.lavpop.com.br/api'
        })
}());
